import App from './App'
import router from './router'
import Vue from "vue";
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import './assets/_variables.scss'
import './assets/_colors.scss'
import './assets/main.css'
import './assets/spacing.css'
import './assets/theme.scss'
import Chart from 'chart.js'
import * as XLSX from 'xlsx'
import VueFormulate from "@braid/vue-formulate";
import '@braid/vue-formulate/dist/snow.css'

Chart.plugins.register({
  id:'colorZones',
  beforeDraw: function(chart, easing) {
    if (chart.config.options.chartArea && chart.config.options.chartArea.zones) {
      var helpers = Chart.helpers;
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;
      var width = chartArea.right - chartArea.left;
      var xaxis = chart.scales['x-axis-0'];
      var yaxis = chart.scales['y-axis-0'];
      const isCenterAreas = chart.config.options.chartArea.isCenterAreas
      let zoneHeight
      if(isCenterAreas){
        const numLevels = chart.config.options.scales.yAxes[0].labels.length;
        zoneHeight = (chartArea.bottom - chartArea.top) / numLevels; // Height of each zone
      }

      chart.config.options.chartArea.zones.forEach(zone =>
        {
          ctx.save();
          ctx.fillStyle = zone.backgroundColor;
          let start, end

          if(isCenterAreas){ // works correctly only if "offset: true" on the axis
            // Calculate the center of the zone
            let zoneCenter = yaxis.getPixelForValue(zone.start);

            // Adjust start and end to center the risk level in the zone
            start = zoneCenter + zoneHeight / 2;
            end = zoneCenter - zoneHeight / 2;
          }
          else{
            start = yaxis.getPixelForValue( zone.start,undefined)
            end = yaxis.getPixelForValue( zone.end,undefined)
          }

          start = start > chartArea.bottom ?  chartArea.bottom : start
          end = end < chartArea.top ?  chartArea.top : end
          ctx.fillRect(chartArea.left, end, width, (start-end));
          ctx.restore();
        }
      )
    }
  }
})
Chart.plugins.register({
  id: 'horizontalLine',
  afterDatasetDraw: function (chart) {
    if (chart.config.options.horizontalLine) {
      const ctx = chart.ctx;
      const xAxis = chart.scales['x-axis-0'];
      const yAxis = chart.scales['y-axis-0'];

      chart.config.options.horizontalLine.forEach(line => {
        ctx.save(); // Save the current drawing state
        ctx.beginPath();
        // Set line properties
        ctx.strokeStyle = line.color || 'rgba(255, 0, 0, 0.7)'; // Set the color of the line
        ctx.lineWidth = line.width || 2; // Set the width of the line
        if (line.lineType === 'dash') {
          ctx.setLineDash([5, 5]); // Set the line as dashed
        } else {
          ctx.setLineDash([]); // Set the line as solid
        }
        const y = yAxis.getPixelForValue(line.value);
        let xStart = line.isShort ? xAxis.left +20 : xAxis.left
        let xEnd = line.isShort ? xAxis.right -20 : xAxis.right
        ctx.moveTo(xStart, y);
        ctx.lineTo(xEnd, y);
        ctx.stroke();
        // Draw text
        if (line.text) {

          ctx.fillStyle = '#666666'; // Set text color
          ctx.font = '12px Arial'; // Set text font
          ctx.fillText(line.text, xAxis.right + 5, y+2); // Draw text on the right of the line
        }
        ctx.restore();
      })
      // Draw the horizontal line
    }
  }
})

Vue.use(VueMaterial)
Vue.use(VueFormulate)


import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCircle
} from '@fortawesome/free-regular-svg-icons'
import {
    faMapMarkerAlt,
    faEllipsisV,
    faCar
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(faCircle, faMapMarkerAlt, faEllipsisV, faCar)
Vue.component('fa-icon', FontAwesomeIcon)
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import VueFlags from "@growthbunker/vueflags";

Vue.use(VueFlags, {
    // Specify the path of the folder where the flags are stored.
    iconPath: '/static/flags/',
});

import navBar from './views/NavBar'
Vue.component('NavBar', navBar)

import sidebar from './views/Sidebar'
Vue.component('Sidebar', sidebar)

import footer from './views/Footer'
Vue.component('Footer', footer)


Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import {LicenseManager} from 'ag-grid-enterprise';
LicenseManager.setLicenseKey(process.env.AG_GRID_KEY);

import * as Sentry from '@sentry/vue';

if(process.env.NODE_ENV !== 'development'){
    Sentry.init({
        Vue,
        dsn: process.env.SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        attachProps: true,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 1.0,
        logErrors: true,
        trackComponents: true
        // tracePropagationTargets by default tracks everything which is the old behavior
    });
}


import {
  getAge,
  get_natjuridica_val,
} from "./utils/filters";

Vue.config.devtools = process.env.ALLOW_DEVTOOLS
Vue.config.productionTip = process.env.PRODUCTION_TIP

import dayjs from 'dayjs'
import moment from 'moment';

require('dayjs/locale/pt-br')
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
dayjs.extend(timezone)
dayjs.extend(utc)

import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { useAuthStore } from '@/stores/auth'
import { useNavigationHistoryStore } from '@/stores/navigationHistory'
import { useUserPreferencesStore } from '@/stores/userPreferences'

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate);

Vue.mixin({
    methods: {
      getAge,
      get_natjuridica_val,
      deepEqual(obj1, obj2) {
      // If both are strictly equal, they are the same
      if (obj1 === obj2) return true;

      // If either is not an object or is null, they're not equal
      if (typeof obj1 !== 'object' || obj1 === null ||
          typeof obj2 !== 'object' || obj2 === null) {
        return false;
      }

      // Compare keys
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
      if (keys1.length !== keys2.length) return false;

      // Recursively compare each key
      for (let key of keys1) {
        if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
          return false;
        }
      }

      return true;
    },
      summarizeDataByOneField(data, field) {
        // Step 1: Calculate the count of each distinct value
        const countMap = {};
        data.forEach(item => {
          const value = this.getValueByNestedKey(field, item)
          countMap[value] = (countMap[value] || 0) + 1;
        });

        // Step 2: Calculate the total number of items
        const totalCount = data.length;

        // Step 3: Calculate percentage and format the result
        const result = [];
        for (const value in countMap) {
          const count = countMap[value];
          const percent = ((count / totalCount) * 100).toFixed(2) + '%';
          result.push({
            [field]: value,
            count,
            percent
          });
        }
        return result;
      },
      showToast({ variant = 'info', title = '', message = '', delay = 5000 }) {
        this.$bvToast.toast(message, {
          title: title,
          variant: variant,
          autoHideDelay: delay,
          solid: true
        });
      },
      showSuccessToast(message) {
        const defaultMessage = 'Operação realizada com sucesso.';
        this.showToast({ variant: 'success', title: 'Sucesso', message: message || defaultMessage });
      },
      showErrorToast(message) {
        const defaultMessage = 'Ocorreu um erro.';
        this.showToast({ variant: 'danger', title: 'Erro', message: message || defaultMessage });
      },
      showInfoToast(message) {
        const defaultMessage = 'Informação.';
        this.showToast({ variant: 'info', title: 'Informação', message: message || defaultMessage });
      },
      // scrRecentMonths
      scrRecentMonthsRequestInfo (scrData, requestedMonths, scrOpenRequest) {
        let latestMonths = this.getConsecutiveMonths(dayjs().subtract(24, 'month').startOf('month').format('YYYY-MM-DD'),
            dayjs().startOf('month').format('YYYY-MM-DD')
        ).slice(0, -2)
        let scrMonthsWithResponse = scrData ? new Set(scrData.map((x) => x.date_reference)) : new Set()
        let res = latestMonths
            .map((x) => ({
                value: x,
                text: x.substring(5, 7) + "/" + x.substring(0, 4),
                hasData: scrMonthsWithResponse.has(x),
                refreshing: [
                    ...requestedMonths,
                    ...(scrOpenRequest ? scrOpenRequest : []),
                ].includes(x),
            }))
            .reverse();
        let requestData = null;
        let today = new Date().toDateString();
        res.forEach((x) => {
            requestData = null;
            if (x.hasData && !x.refreshing) {
                requestData = scrData.filter(
                    (y) => y.date_reference === x.value
                )[0];
            }
            x["inserted_at"] = requestData
                ? dayjs(requestData.inserted_at).format("DD/MM/YYYY")
                : null;
            x["hasInserted_atToday"] = requestData
                ? new Date(requestData.inserted_at).toDateString() === today
                : false;
            x["inGatheringDataPeriod"] =
                x.hasData && !x.refreshing
                    ? dayjs(requestData.inserted_at).subtract(100, 'days') < dayjs(requestData.date_reference)
                    : false;
            x["canRequest"] =
                !x.refreshing &&
                (!x.hasData || (x.inGatheringDataPeriod && !x.hasInserted_atToday));
        });
        return res;
      },
      getHost () {
        const hostName = window.location.hostname
        let port = '8080'
        if (hostName === 'localhost' || hostName === '127.0.0.1') {
          return `http://${hostName}:${port}`
        } else {
          return ''
        }
      },
      navigateTabsByHashAndSavedPreferences (preferenceCategory, tabsPath, defaultSelection, clickedTabFunc, getNavigationPreferencesFunc) {
        let pathLevels = tabsPath ? tabsPath.split('/') : null
        let tabNameFromHash = this.getTabNameFromURI_Fragment(pathLevels ? pathLevels.length : 0)
        if (tabNameFromHash) {
          clickedTabFunc(tabNameFromHash, true)
          this.removeURI_FragmentFromPathIfAtEndPoint(tabNameFromHash)
        } else {
          let selected = getNavigationPreferencesFunc(preferenceCategory)
          if (!tabsPath) {
            if (selected && 'latest' in selected && selected.latest) {
              clickedTabFunc(selected.latest, false)
            }
          } else if (selected && pathLevels[0] in selected && selected[pathLevels[0]]) {
            if (pathLevels.length === 1) {
              clickedTabFunc(selected[pathLevels[0]], false)
            } else {
              if (pathLevels[1] in selected[pathLevels[0]] && selected[pathLevels[0]][pathLevels[1]]) {
                clickedTabFunc(selected[pathLevels[0]][pathLevels[1]], false)
              } else {
                clickedTabFunc(defaultSelection, false)
              }
            }
          } else {
            clickedTabFunc(defaultSelection, false)
          }
        }
      },
      getTabNameFromURI_Fragment (positionInURI) {
        if (this.$route.hash) {
          let hashLevels = this.$route.hash.split('/')
          if (positionInURI < hashLevels.length && hashLevels[positionInURI].replace('#', '')) {
            return hashLevels[positionInURI].replace('#', '')
          }
        }
        return null
      },
      removeURI_FragmentFromPathIfAtEndPoint (endPoint) {
        if (this.$route.hash && this.$route.hash.substring(this.$route.hash.length - endPoint.length) === endPoint) {
          this.removeURI_FragmentFromPath()
        }
      },
      removeURI_FragmentFromPath () {
        let pathLength = this.$route.path.split('/').length
        window.history.pushState({}, '', this.$route.path.split('/')[pathLength - 1])
      },
      setURI_Fragment (newHash) {
        if (newHash) {
          window.history.pushState({}, '', this.$route.path + '#' + newHash)
        }
      },
      // works only if has up to 2 decimal numbers
      accurateDecimalAddition (a, b) {
        return ((a * 100) + (b * 100)) / 100
      },
      generateColorBasedOnString (str) {
        var hash = 0
        for (var i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash)
        }
        var color = '#'
        for (var i = 0; i < 3; i++) {
          var value = (hash >> (i * 8)) & 0xff
          color += ('00' + value.toString(16)).substr(-2)
        }
        return color
      },
      generateFullCNPJ(cnpj8) {
        // Remove mask characters only; preserve letters for alphanumeric CNPJ
        const root = cnpj8.replace(/[.\-\/\s]/g, '');
        if (root.length !== 8) {
          throw new Error('CNPJ root must have exactly 8 digits');
        }

        // Add fixed branch (0001)
        const base = root + '0001';

        // Function to calculate verification digit
        function calcDV(cnpjPartial) {
          const weights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
          const sum = cnpjPartial
            .split('')
            .map((n, i) => parseInt(n, 10) * weights[weights.length - cnpjPartial.length + i])
            .reduce((a, b) => a + b, 0);
          const remainder = sum % 11;
          return remainder < 2 ? '0' : String(11 - remainder);
        }

        const firstDV = calcDV(base);
        const secondDV = calcDV(base + firstDV);

        return base + firstDV + secondDV;
      },
      isCnpj14ValidByVerificationDigits (cnpj14) {
        if (cnpj14) {
          cnpj14 = '' + cnpj14
          cnpj14 = cnpj14.replace(/[.\-\/\s]/g, '')
          // Alphanumeric CNPJ: checksum algorithm not implemented yet — accept if length is 14
          if (!/^\d+$/.test(cnpj14)) {
            return cnpj14.length === 14
          }
          if (cnpj14.length > 8) {
            while (cnpj14.length < 14) {
              cnpj14 = '0' + cnpj14
            }
            let companyDigits = cnpj14.substring(0, cnpj14.length - 2)
            let multiDigits = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
            while (companyDigits.length < 14) {
              let sum = 0
              for (var i=0; i< multiDigits.length; i++) {
                  sum += multiDigits[i] * companyDigits[i]
              }
              let modResult = sum % 11
              let verDigit = null
              if (modResult < 2) {
                verDigit = '0'
              }
              else {
                verDigit = 11 - modResult
              }
              companyDigits = companyDigits + verDigit
              multiDigits = [6, ...multiDigits]
            }
            return companyDigits === cnpj14
          }
        }
        return false
      },
      isValidCnpj (cnpj) {
        cnpj = cnpj.toString()
        if (cnpj) {
          // if cnps is formatted
          if (cnpj.length > 8 && cnpj.length !== 14) {
            if (
              !(
                /^(\d{2}).(\d{3}).(\d{3})$/.test(cnpj) ||
                /^(\d{2}).(\d{3}).(\d{3})\/(\d{4}).(\d{2})$/.test(cnpj)
              )
            ) {
              return false
            }
          }
          cnpj = cnpj.replace(/[.\-\/\s]/g, "")
          // Alphanumeric CNPJ: checksum algorithm not implemented yet — accept if length is valid
          if (!/^\d+$/.test(cnpj)) {
            return cnpj.length === 8 || cnpj.length === 14
          }
          if (cnpj.length === 8) {
            return true
          } else if (cnpj.length === 14) {
            return this.isCnpj14ValidByVerificationDigits(cnpj)
          }
        }
        return false
      },
      isCpfValidByVerificationDigits(cpf){
        const digits = cpf.split('').map(Number);
        if (digits.length !== 11 || +cpf === 0) return false; // +cpf converts string to number

        const calculateMod = (multiplier) => (
            multiplier.reduce((sum, num, i) => sum + num * digits[i], 0) % 11 % 10
        );

        const firstMultiplier = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0];
        const secondMultiplier = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

        const firstDigit = calculateMod(firstMultiplier);
        if (firstDigit !== digits[9]) return false;

        const secondDigit = calculateMod(secondMultiplier);
        return secondDigit === digits[10];
      },
      isValidCpf(cpf){
        if (cpf){
          cpf = cpf.toString()
          // if cpf is formatted
          if (cpf.length > 11) {
            if (!(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/.test(cpf))
            ){
              return false
            }
          }
          if (cpf.replace(/\D/g, '').length === 11) {
            return true
          }
        }
        return false
      },
      isValidBrMoneyOrNumber(val){
        return !isNaN(Number(val)) ||
            this.isBRMoneyFormat(val)
            ? true
            : false;
      },
      isValidPercent(val){
        if(val===null || val ==='') return false
        let valNum = Number(val)
        return !isNaN(valNum) && valNum >= 0 && valNum <= 100
      },
      openFullScreen (elementId) {
        var elem = document.getElementById(elementId)
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen()
        }
      },
      closeFullscreen () {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      },
      multiplyFloatBy100 (num) {
        let textNum = (""+num).split(".");
        if(textNum.length === 2){
            if(textNum[1].length >1){
                num = parseInt(textNum[0]+textNum[1].substring(0,2))
            }
            else if (textNum[1].length ===1){
                num = parseInt(textNum[0]+textNum[1]+"0")
            }
        }
        else{
            num = parseInt(textNum[0]) *100
        }
        return num
      },
      getValueByNestedKey(keyString, obj) {
        const keys = keyString.split('.')
        let value = obj

        for (const key of keys) {
          if (value && typeof value === 'object' && key in value) {
            value = value[key]
          } else {
            // Key not found in the nested structure
            return undefined
          }
        }
        return value
      },
      exportToExcelWithDataPrep(items, fields, fileName, tableName=null) {
        // This function prepers the data for the excel export format.
        // It exports all the available data, and only columns that are saved in Vuex or are set to default.
        let data = []
        let tmpRow = null
        let tableColumnsKeyLabel = {}

        if(tableName){
          const userPreferencesStore = useUserPreferencesStore();
          let vuexTables = userPreferencesStore.table
          let savedColumns = this.existsIn(tableName, vuexTables) && vuexTables[tableName].chosen_columns
          if(savedColumns && savedColumns.length){
            fields = fields.filter(field => savedColumns.includes(field.key))
          }
        }
        else{
          fields = fields.filter(field => field.isDefault)
        }

        fields.forEach((row) => {
          tableColumnsKeyLabel[row.key] = row.label
        })

        let allKeys = fields.map(f => ({key: f.key, label: f.label}))
        let keysWithDateFormat = fields.filter(x => 'formatter' in x && x.formatter === 'dateFormatter')
        keysWithDateFormat = keysWithDateFormat && keysWithDateFormat.length ? Object.fromEntries(keysWithDateFormat.map((item, index) => [item.key, null])):null
        items.forEach((row) => {
          tmpRow = {}
          for (const {key, label} of allKeys) {
            let value
            if (key.includes('.')) {
              value = this.getValueByNestedKey(key, row)
            } else {
              value = row[key]
            }
            if (label.includes('Data') || (keysWithDateFormat && key in keysWithDateFormat)) {
              value = value ? this.get_dayjs_date(value).format('DD/MM/YYYY') : null
            }
            // value = key.includes('.') ? this.getValueByNestedKey(key, row) : row[key]
            tmpRow[tableColumnsKeyLabel[key]] = value
          }
          data.push(tmpRow)
        })
        this.exportToExcel(data, fileName)
      },
      exportToExcel (data, fileName) { // On Click Excel download button
        var wb = XLSX.utils.book_new() // make Workbook of Excel
        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data), '') // sheetAName is name of Worksheet
        // export Excel file
        XLSX.writeFile(wb, fileName + '.xlsx') // name of the file is 'book.xlsx'
      },
      getFullMonthName (val) {
        let months = {
          '01': 'Janeiro',
          '02': 'Fevereiro',
          '03': 'Marchar',
          '04': 'Abril',
          '05': 'Maio',
          '06': 'Junho',
          '07': 'Julho',
          '08': 'Agosto',
          '09': 'Setembro',
          '10': 'Outubro',
          '11': 'Novembro',
          '12': 'Dezembro'
        }
        return months[val]
      },
      // monthNumber - [1-12]
      getLastDayOfMonth (year, monthNumber) {
        return new Date(parseInt(year), parseInt(monthNumber), 0).getDate()
      },
      getComplianceProductMapping(prod){
        const map = {
          credit: "CRÉDITO",
          current_account: "CONTA CORRENTE",
          cambio: "CÂMBIO",
          pj_exchange: "CÂMBIO",
        }
        return map[prod]
      },
      getScrMapping (val) {
        let scrMapping = {
          tipo: 'Produtos',
          secao: 'Categoria'
        }
        return scrMapping[val]
      },
      getScrElementCode (element) {
        let obj = {
          'Limites de Crédito':'H',
          'Créditos a Liberar':'G',
          'Coobrigacoes':'E',
          'Prejuízo':'B',
          'Vencido':'A2',
          'A vencer':'A1',
          'Repasses':'D',
        }
        return obj[element]
      },
      getScrElementMapping (val) {
        let elementoMapping = {
          'H': {
              'divisao': 'Limites de Crédito',
              'classe_principal': 'Limites de Crédito',
              'natureza': 'Limites de Crédito',
              'elemento': 'Limites de Crédito',
              'color': '#dc0ab4',
              'order': 5
          },
          'G': {
              'divisao': 'Créditos a Liberar',
              'classe_principal': 'Créditos a Liberar',
              'natureza': 'Créditos a Liberar',
              'elemento': 'Créditos a Liberar',
              'color':'#bd7ebe',
              'order': 6
          },
          'E': {
              'divisao': 'Responsabilidade',
              'classe_principal': 'Coobrigacoes',
              'natureza': 'Coobrigacoes',
              'elemento': 'Coobrigacoes',
              'color':'#69D0CB',
              'order': 4
          },
          'B': {
              'divisao': 'Responsabilidade',
              'classe_principal': 'Carteira de Crédito',
              'natureza': 'Prejuízo',
              'elemento': 'Prejuízo',
              'color':'#e60049',
              'order': 1
          },
          'A2': {
              'divisao': 'Responsabilidade',
              'classe_principal': 'Carteira de Crédito',
              'natureza': 'Carteira Ativa',
              'elemento': 'Vencido',
              'color':'#ffa300',
              'order': 2

          },
          'A1': {
              'divisao': 'Responsabilidade',
              'classe_principal': 'Carteira de Crédito',
              'natureza': 'Carteira Ativa',
              'elemento': 'A vencer',
              'color':'#5ad45a',
              'order': 3
          },
          'D': {
              'divisao': 'Responsabilidade',
              'classe_principal': 'Repasses',
              'natureza': 'Repasses',
              'elemento': 'Repasses',
              'color':'#4A936F',
              'order': 7
          }
        }
        return elementoMapping[val]
      },
      getPercent (val, totalVal) {
        return Math.round((val / totalVal) * 1000) / 10
      },
      getConsecutiveDays (startDate, endDate) {
        let start = moment(startDate)
        let end = moment(endDate)
        let result = []
        if (start && end && start.isBefore(end)) {
          while (start.isSameOrBefore(end, 'day')) {
            result.push(start.format('YYYY-MM-DD'))
            start.add(1, 'day')
          }
        }
        return result
      },
      getConsecutiveMonths (startDate, endDate){
          let start = moment(startDate)
          let end = moment(endDate)
          let result = []
          if(start && end && start.isBefore(end)) {
            while (start.isBefore(end)) {
              result.push(start.format("YYYY-MM-01"))
              start.add(1, 'month')
            }
            result.push(start.format("YYYY-MM-01"))
          }
          else if(startDate === endDate){
            result.push(start.format("YYYY-MM-01"))
          }
          return result
        },
        getSituacaoDesc(situacao){
          let fields = {
            '01': 'Nula',
            '02': 'Ativa',
            '03': 'Suspensa',
            '04': 'Inapta',
            '08': 'Baixada'
          }
          return fields[situacao]
        },
        getBadgeVariant(situacao){
          let fields = {
            '01': '#F7D757',
            '02': '#3BA865',
            '03': '#F7D757',
            '04': '#F7D757',
            '08': '#EB484C'
          }
          return fields[situacao]

        },
        startDynamicInterval(callback) {
          // fetch function: first 120 seconds-runs every 5 seconds, after that-every 30 seconds
          let intervalId;
          let elapsedTime = 0;
          let isCallbackRunning = false; // Flag to track if callback is running

          // Function to safely execute the callback
          const executeCallback = async () => {
            if (isCallbackRunning) {
              return;
            }

            isCallbackRunning = true;
            try {
              await callback(); // Wait for the callback to complete
            } catch (error) {
              console.error('Error during callback execution:', error);
            } finally {
              isCallbackRunning = false; // Reset the flag
            }
          };

          // Initial interval of 5 seconds
          intervalId = setInterval(() => {
            // Call the callback function
            executeCallback()

            // Increment elapsed time
            elapsedTime += 5;

            // After 2 minutes (120 seconds), switch to 30-second interval
            if (elapsedTime > 120) {
              clearInterval(intervalId);

              // Start new interval with 20-second frequency
              intervalId = setInterval(() => {
                executeCallback();
              }, 30000);
            }
          }, 5000);
          return intervalId
        },

        getTimePassed(value){
          if(!value) return;

          let timePassed = getAge(value)
          timePassed = timePassed.replace('-','')
          let text = new Date() < new Date(value) ? 'Em' : 'Antes de'
          return text+' '+timePassed
        },
        get_dayjs_date (date, format=null) {
          dayjs.locale('pt-br')
          let result
          if (typeof date === 'string' && date && date.length === 10){
            result = dayjs.utc(date)
          }
          else{
            result = dayjs(date)
          }
          if(format === 'br'){
            result = result.format('DD/MM/YYYY')
          }
          return result
        },
        getPastDate (daysAgo,fromDate=new Date()) {
          return this.get_dayjs_date(fromDate)
            .add(parseInt(daysAgo) * -1, "day")
            .format("YYYY-MM-DD");
        },
        sort_dayjs_descending(dates){
          return dates.sort((a,b) => (dayjs(a).isAfter(dayjs(b)) ? -1 : 1))
        },
        existsIn(key, data){
          return key in data && data[key] !== null
        },
      isCellCnpj(val){
        let label = val.field.label
        if(label){
          return val.field.label.toLowerCase() ==='cnpj' ? true : false
        }
        return false
      },
      formatCpf(value){
      //   Removes leading zeros
      //   Formats cpf with asterisks(*)
        if (!value) return ''
        if (typeof value === 'object') {
          return 'Invalid'
        }
        if(value.length === 14 && value.substring(0,3) === '000'){
          value = value.substring(3)
        }
        const cpf = value.match(/.{1,3}/g)
        let finalstring = ''
        if (value.length === 11) {
          cpf.forEach((row, index) => finalstring += index === 0 ? row : row.length === 3 ? '.' + row : '-' + row)
          return finalstring
        }

        return cpf
      },
      formatCpfCnpj(value) {
        if (!value) return ''
        if (typeof value === 'object') {
          return 'Invalid'
        }
        const govCode = value.replace(/[.\-\/\s]/g, '')
        if (value.length === 8) {
          return govCode.replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2.$3");
        }
        else if (value.length === 11) {
          return govCode.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
        }
        else if (value.length === 14) {
          return govCode.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
        }
        return govCode
      },
      hasConsultAccess(consultType){
          const authStore = useAuthStore(pinia)
          if(authStore.permissions && Object.keys(authStore.permissions).includes(consultType) && authStore.permissions[consultType] === 'consulter'){
              return true
          }else{
              return false
          }
      },
      hasViewerAccess(consultType) {
        const authStore = useAuthStore(pinia)
        if(authStore.permissions && Object.keys(authStore.permissions).includes(consultType) && authStore.permissions[consultType] !== null){
            return true
        }else{
            return false
        }
      },
      startProgressBar() {
          this.$root.$children[0].$refs.progressBar.start()
      },
      stopProgressBar() {
          this.$root.$children[0].$refs.progressBar.done()
      },
      failProgressBar() {
          this.$root.$children[0].$refs.progressBar.fail()
      },
      isEnvDevelopment(){
        return process.env.NODE_ENV === 'development'
      },
      myFormatDateString(value) {
        if (value) {
          let data = value.split('-')
          return data[2] + '/' + data[1] + '/' + data[0]
        }
      },
      formatDatetime(value, format) {
          if (value) {
              return moment(String(value)).format(format)
          }
      },
      hasDictData(dict){
        return !!Object.keys(dict).length
      },
      formatMoney(value, showDecimal = false) {
        if ((!value && value !== 0) || value === '-') return ''
        let newValue = new Intl.NumberFormat('pt-BR',
          {currency: 'BRL', style: 'currency'})
          .format(value)
        if (!showDecimal) {
          newValue = newValue.split(',')[0]
        }
        return newValue
      },
      formatMoneyCompact(value){
        if (!value) {value = 0}

        return new Intl.NumberFormat('pt-BR',
          {
            currency: 'BRL',
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
          .format(value)
      },
      getCurrencySymbol(currencyCode){
        if(currencyCode){
          let data =  new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencyCode,
          }).format("0")
          return data.replaceAll(" ","").split("0")[0]
        }
      },
      formatMoneyByCurrency(value,currency) {
        if ((!value && value !== 0) || value === '-') return ''
        let newValue = new Intl.NumberFormat('pt-BR',
          {currency: currency, style: 'currency'})
          .format(value)
        return newValue
      },
      formatMoneyKM(val, k = 2) {
        let isMinus = val < 0 ?true:false
        let absValue = Math.abs(val)
        if (absValue >= 1000000000) {
          return `${isMinus?'- ':''} R$ ${((absValue / 1000000000).toFixed(k) * 1).toString().replace(".",",")}Bi`;
        } else if (Math.abs(val) >= 1000000) {
          return `${isMinus?'- ':''} R$ ${((absValue / 1000000).toFixed(k) * 1).toString().replace(".",",")}MM`;
        } else if (Math.abs(val) >= 1000) {
          return `${isMinus?'- ':''} R$ ${((absValue / 1000).toFixed(k) * 1).toString().replace(".",",")}Mil`;
        } else {
          return `${isMinus?'- ':''} R$ ${absValue}`;
        }
      },
      formatCompactNumber(number) {
        if (number) {
          const formatter = Intl.NumberFormat('pt-BR', { notation: 'compact' })
          return formatter.format(number)
        }
        return null
      },
      formatNumber(number, maxFractionDigits=null) {
        if (number) {
          let options = (maxFractionDigits || maxFractionDigits===0) ? {maximumFractionDigits: maxFractionDigits} : {}
          const formatter = Intl.NumberFormat('pt-BR', options)
          return formatter.format(number)
        }
        return number
      },
      isBRMoneyFormat (val) {
        let data = '' + val
        return (data.includes('.') || data.includes(',')) && /^\s*(?:\-){0,1}\s*(?:[1-9]\d{0,2}(?:\.\d{3})*|0)(?:,\d{1,2})?$/.test(data);
      },
      fromBRMoneyToNumber (val) {
        let numberOfDots = (String(val).match(/\./g) || []).length;
        if (val) {
          if (
            val[val.length - 2] === "," ||
            val[val.length - 3] === "," ||
            numberOfDots > 1
          ) {
            val = val.replaceAll(".", "").replace(",", ".");
          } else if (
            numberOfDots === 1 &&
            val.length >= 4 &&
            val[val.length - 4] === "."
          ) {
            val = val.replaceAll(".", "");
          }
        }
        return val;
      },
      formatNumberToRoman (num) {
        let romanNumerals = [
          { value: 1000, numeral: 'M' },
          { value: 900, numeral: 'CM' },
          { value: 500, numeral: 'D' },
          { value: 400, numeral: 'CD' },
          { value: 100, numeral: 'C' },
          { value: 90, numeral: 'XC' },
          { value: 50, numeral: 'L' },
          { value: 40, numeral: 'XL' },
          { value: 10, numeral: 'X' },
          { value: 9, numeral: 'IX' },
          { value: 5, numeral: 'V' },
          { value: 4, numeral: 'IV' },
          { value: 1, numeral: 'I' }
        ]
        if (isNaN(num)) {
          return ''
        }
        let romanNumeral = ''
        for (let i = 0; i < romanNumerals.length; i++) {
          while (num >= romanNumerals[i].value) {
            romanNumeral += romanNumerals[i].numeral
            num -= romanNumerals[i].value
          }
        }
        return romanNumeral
      },
        cnae_format(cnae){
          if (cnae) {
            if (/^\d{3}$/.test(cnae)) {
              // Format 3-digit CNAE: "502" => "50.2"
              return cnae.replace(/^(\d{2})(\d{1})$/, "$1.$2");
            } else if (/^\d{5}$/.test(cnae)) {
              // Format 5-digit CNAE: "50220" => "50.22-0"
              return cnae.replace(/^(\d{2})(\d{2})(\d{1})$/, "$1.$2-$3");
            } else if (/^\d{7}$/.test(cnae)) {
              // Format 7-digit CNAE: "5022012" => "5022-0/12"
              return cnae.replace(/^(\d{4})(\d{1})(\d{2})$/, "$1-$2/$3");
            }
          }
          return '';
        },
        propercase(text){
          return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase()
        },
        nameCase(text){
          if (text) {
            let name = ''
            let textList = text.split(' ')
            textList.forEach(word => name = name.concat(!(['da','e','em','de'].includes(word.toLowerCase())) ? ' ' + word.charAt(0).toUpperCase() + word.substr(1).toLowerCase() : ' ' + word.toLowerCase()))
            return name
          }
          return null
        },
        // cnpjcpfLink(code){
        //   let gov_id = this.formatCpfCnpj(code)
        //   // let link =
        //   // return `<router-link :to="${'/cnpj/'+code}">${gov_id}</router-link>`
        //   return '<strong>abc</strong>'
        // },
      getIndicatorError(code, text_0){
      let map = {
        '0': text_0,
        '299' : 'Safra não maturada',
        '301' : 'Opt-out do Cadastro Positivo',
        '302' : 'Suspensão de acesso ao Acore',
        '303' : 'Sem histórico de credito, ou com histórico, mas não comunicado, ou dentro do prazo legal de comunicação.',
        '304' : 'Não há informações suficientes para o cálculo',
        '305' : 'CPF inválido',
        '306' : 'Menor de Idade',
        '307' : 'óbito',
        '308' : 'PEP/VIP',
        '399' : 'Data futura',
      }
      return map[code] || null
    },
      mapIndicator(code){
      let map = {
        'PF_EM_ITS02': {
          title: 'Contratações credito emergencial',
          description:'Pontuações maiores indicam maiores valores de crédito rotativo contratados',
          group:'PERFIL FINANCEIRO',
          bgColor:'#59A557',
          '0_message': 'Não há utilização de crédito emergencial no período calculado',
          '304_message': 'Não possui histórico de uso de produtos emergenciais',
        },
        'PF_PC_PRD01': {
          title: 'Tipo de contratação',
          description:'Pontuações maiores indicam contratações de produtos associados a perfis menos arriscados',
          group:'PERFIL FINANCEIRO',
          bgColor:'#59A557',
          '0_message': 'Não possui contratos no período calculado',
          '304_message': 'Não possui contratação nos últimos 365 dias. (nem todos os produtos são contabilizados)',
        },
        'PP_AV_AMP02': {
          title: 'Endividamento contrato e credores',
          description:'Pontuações maiores indicam um número maior de credores e/ou contratos distintos em aberto',
          group:'PONTUALIDADE DE PAGAMENTO',
          bgColor:'#755CF6',
          '0_message': 'Não possui parcelas em atraso no período calculado',
          '304_message': 'Não possui histórico de uso de cartão, consórcio e empréstimo',
        },
        'PP_AV_GRV02': {
          title: 'Gravidade em atrasos',
          description:'Pontuações maiores indicam débitos vigentes com atrasos mais severos',
          group:'PONTUALIDADE DE PAGAMENTO',
          bgColor:'#755CF6',
          '0_message': 'Não possui parcelas em atraso no período calculado',
          '304_message': 'Não possui parcelas no período',
        },
        'PP_PD_CPG02': {
          title: 'Pontualidade de pagamento',
          description:'Pontuações maiores indicam a realização de mais pagamentos de parcelas sem atraso',
          group:'PONTUALIDADE DE PAGAMENTO',
          bgColor:'#755CF6',
          '0_message': 'Não possui pagamentos realizados em dia',
          '304_message': 'Não possui pagamento nos últimos 365 dias OU não possui parcelas em aberto.',
        },
        'RM_BC_FRQ01': {
          title: 'Busca por crédito mensal',
          description:'Pontuações maiores indicam maior frequência de novos contratos',
          group:'RELACIONAMENTO COM O MERCADO',
          bgColor:'#4BAFEA',
          '0_message': 'Não possui contratações no período calculado',
          '304_message': 'Não possui histórico de contratos',
        },
        'RM_PR_ETB01': {
          title: 'Estabilidade do relacionamento',
          description:'Pontuações maiores indicam relacionamentos mais instáveis com os credores',
          group:'RELACIONAMENTO COM O MERCADO',
          bgColor:'#4BAFEA',
          '0_message': 'N/A',
          '304_message': 'Não possui histórico de contratações',
        },
      }
      return map[code]
    },
        formatPhone(p_num){
          if(p_num){
            let len = p_num.length
            if(len === 10){
              p_num = '('+ p_num.substring(0,2) + ') ' +  p_num.substring(2,6) + '-' + p_num.substring(6,len)
            }
            else if(len === 11){
              p_num = '('+ p_num.substring(0,2) + ') ' +  p_num.substring(2,7) + '-' + p_num.substring(7,len)
            }
          }
          return p_num
        },
        getMotivoSituacao(situacao){
          let fields = {
          '00': 'ATIVA',
          '01': 'EXTINÇÃO POR ENCERRAMENTO LIQUIDAÇÃO VOLUNTÁRIA',
          '02': 'INCORPORAÇÃO',
          '03': 'FUSÃO',
          '04': 'CISÃO TOTAL',
          '05': 'ENCERRAMENTO DA FALÊNCIA',
          '06': 'ENCERRAMENTO DA LIQUIDAÇÃO',
          '07': 'ELEVAÇÃO A MATRIZ',
          '08': 'TRANSPASSE',
          '09': 'NÃO INÍCIO DE ATIVIDADE',
          '10': 'EXTINÇÃO PELO ENCERRAMENTO DA LIQUIDAÇÃO JUDICIAL',
          '11': 'ANULAÇÃO POR MULTICIPLIDADE',
          '12': 'ANULAÇÃO ONLINE DE OFICIO',
          '13': 'OMISSA CONTUMAZ',
          '14': 'OMISSA NÃO LOCALIZADA',
          '15': 'INEXISTENTE DE FATO',
          '16': 'ANULAÇÃO POR VÍCIOS',
          '17': 'BAIXA INICIADA E AINDA NÃO DEFERIDA',
          '18': 'INTERRUPÇÃO TEMPORÁRIA DAS ATIVIDADES',
          '19': 'OMISSO DE DIRPJ ATÉ 5 EXERCÍCIOS',
          '20': 'EM CONDIÇÃO DE INAPTIDÃO',
          '21': 'PEDIDO DE BAIXA INDEFERIDA',
          '22': 'RESTABELECIMENTO COM CERTIDÃO POSITIVA COM EFEITO DE NEGATIVA',
          '23': 'COM PENDÊNCIA FISCAL',
          '24': 'POR EMISSÃO CERTIDÃO NEGATIVA',
          '25': 'CERTIDÃO POSITIVA COM EFEITO DE NEGATIVA',
          '26': 'IRREGULARIDADE DE PAGAMENTO',
          '27': 'IRREGULARIDADE DE RECOLHIMENTO E EXIGIBILIDADE SUSPENSA',
          '28': 'TRANSFERÊNCIA FILIAL CONDIÇÃO MATRIZ',
          '29': 'AGUARDANDO CONF. DE DIRPJ/DIPJ',
          '30': 'ANR - AGUARDANDO CONF. DE DIRPJ/DIPJ',
          '31': 'EXTINÇÃO DA FILIAL',
          '32': 'INEXISTENTE DE FATO – ADE/COSAR',
          '33': 'TRANSFERÊNCIA DO ÓRGÃO LOCAL A CONDIÇÃO DE FILIAL DO ÓRGÃO REGIONAL',
          '34': 'ANULAÇÃO DE INSCRIÇÃO INDEVIDA',
          '35': 'EMPRESA ESTRANGEIRA AGUARDANDO DOCUMENTAÇÃO',
          '36': 'PRÁTICA IRREGULAR DE OPERAÇÃO DE COMERCIO EXTERIOR',
          '37': 'BAIXA DE PRODUTOR RURAL',
          '38': 'BAIXA DEFERIDA PELA RFB AGUARDANDO ANALISE DO CONVENENTE',
          '39': 'BAIXA DEFERIDA PELA RFB E INDEFERIDA PELO CONVENENTE',
          '40': 'BAIXA INDEFERIDA PELA RFB E AGUARDANDO ANALISE DO CONVENENTE',
          '41': 'BAIXA INDEFERIDA PELA RFB E DEFERIDA PELO CONVENENTE',
          '42': 'BAIXA INDEFERIDA PELA RFB E SEFIN, AGUARDANDO ANALISE SEFAZ',
          '43': 'BAIXA DEFERIDA PELA RFB, AGUARDANDO ANALISE DA SEFAZ E INDEFERIDA PELA SEFIN',
          '44': 'BAIXA DEFERIDA PELA RFB E SEFAZ, AGUARDANDO ANALISE SEFIN',
          '45': 'BAIXA DEFERIDA PELA RFB, AGUARDANDO ANALISE DA SEFIN E INDEFERIDA PELA SEFAZ',
          '46': 'BAIXA DEFERIDA PELA RFB E SEFAZ E INDEFERIDA PELA SEFIN',
          '47': 'BAIXA DEFERIDA PELA RFB E SEFIN E INDEFERIDA PELA SEFAZ',
          '48': 'BAIXA INDEFERIDA PELA RFB, AGUARDANDO ANALISE SEFAZ E DEFERIDA PELA SEFIN',
          '49': 'BAIXA INDEFERIDA PELA RFB, AGUARDANDO ANALISE DA SEFAZ E INDEFERIDA PELA SEFIN',
          '50': 'BAIXA INDEFERIDA PELA RFB, DEFERIDA PELA SEFAZ E AGUARDANDO ANALISE DA SEFIN',
          '51': 'BAIXA INDEFERIDA PELA RFB E SEFAZ, AGUARDANDO ANALISE DA SEFIN',
          '52': 'BAIXA INDEFERIDA PELA RFB, DEFERIDA PELA SEFAZ E INDEFERIDA PELA SEFIN',
          '53': 'BAIXA INDEFERIDA PELA RFB E SEFAZ E DEFERIDA PELA SEFIN',
          '54': 'BAIXA - TRATAMENTO DIFERENCIADO DADO AS ME E EPP (LEI COMPLEMENTAR NUMERO 123/2006)',
          '55': 'DEFERIDO PELO CONVENENTE, AGUARDANDO ANALISE DA RFB',
          '60': 'ARTIGO 30, VI, DA IN 748/2007',
          '61': 'INDICIO INTERPOS. FRAUDULENTA',
          '62': 'FALTA DE PLURALIDADE DE SOCIOS',
          '63': 'OMISSÃO DE DECLARAÇÕES',
          '64': 'LOCALIZAÇÃO DESCONHECIDA',
          '66': 'INAPTIDÃO',
          '67': 'REGISTRO CANCELADO',
          '70': 'ANULAÇÃO POR NÃO CONFIRMADO ATO DE REGISTRO DO MEI NA JUNTA COMERCIAL',
          '71': 'INAPTIDÃO (LEI 11.941/2009 ART.54)',
          '72': 'DETERMINAÇÃO JUDICIAL',
          '73': 'OMISSÃO CONTUMAZ',
          '74': 'INCONSISTÊNCIA CADASTRAL',
          '80': 'BAIXA REGISTRADA NA JUNTA, INDEFERIDA NA RFB',
          }
          return fields[situacao]

        },
    }
})

import {isAdmin, isLoggedIn} from "@/utils/authFunctions"
import {addLookupLog} from "@/utils/lookupLogFunctions"

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore(pinia); // Access the Pinia store
  const navigationHistoryStore = useNavigationHistoryStore(pinia); // Access the Pinia store
   if (isLoggedIn()) {
    let isWebsiteLive = document.cookie.split(`isWebsiteLive=`)
    if (isWebsiteLive.length === 2 && isWebsiteLive[1].split(';')[0] === 'false'){
      isWebsiteLive= false
    } else {
      isWebsiteLive= true
    }
    if(!isWebsiteLive && to.fullPath !== '/new-website-url' && to.fullPath !== '/admin/website-status'){
      next({path: '/new-website-url'})
    }
    else {
      let cnpj8 = null
      let replaceURL = false
      if(Object.keys(to.params).includes('cnpj')){
        if(to.params.cnpj.length > 8){
          cnpj8 = to.params.cnpj.replace(/[.\-\/\s]/g,'').substring(0,8)
          to.params.cnpj = cnpj8
          replaceURL = true
        }
        else{
          addLookupLog({'lookup': to.params, 'referrerLookup': navigationHistoryStore.lastUrl.params, 'referrerRaw': navigationHistoryStore.lastUrl.raw}).then()
        }
      }
      if(Object.keys(to.params).includes('cpf_nome') ||  Object.keys(to.params).includes('cpf')) {
        addLookupLog({'lookup': to.params, 'referrerLookup': navigationHistoryStore.lastUrl.params, 'referrerRaw': navigationHistoryStore.lastUrl.raw}).then()
      }
      if(Object.keys(to.params).includes('group_id')) {
        addLookupLog({'lookup': to.params, 'referrerLookup': navigationHistoryStore.lastUrl.params, 'referrerRaw': navigationHistoryStore.lastUrl.raw}).then()
      }
      if (authStore.user === null || (from.path.includes('admin') && !to.path.includes('admin'))) {
        authStore.refreshUser()
      }
      if(Object.keys(to.meta).includes('accountAdmin') && to.meta.accountAdmin){
           if(!authStore.isAccountAdmin){
              next({path: '/'})
          }else{
              next()
          }
      }
      else{
          if (to.path === '/' || to.path === '/login') {
            next({path: '/company-lookup'})
          }
          else if(to.path === '/admin' && isAdmin()){
            next({path: '/admin/users'})
          }
          else if (to.path.includes('admin') && !isAdmin()) {
            next({path: '/company-lookup'})
          }
          else {
            if(Object.keys(to.params).includes('cnpj') && replaceURL){
              next({path:'/cnpj/'+cnpj8,replace:true})
            }
            else{
              next()
            }
          }
      }

    }
  }
  else {
        let nextRoute = ''
        if (to.meta.protected || to.path === '/') {
            if(to.path === '/' || to.path === '/login'){
                if(Object.keys(to.query).includes('next')){
                    nextRoute = to.query.next
                }else{
                    nextRoute = ''
                }
            }else{
                nextRoute = to.path
            }
            next({path: '/login', query: {'next': nextRoute}})
        } else {
            next()
        }
    }
})


new Vue({
  el: '#app',
  router,
  pinia,
  render: h => h(App)
})
